import { ConfigProvider } from "antd";

export default function ThemeProvider({ children }) {
  return (
    <ConfigProvider
      theme={{
        hashed: false,
        token: {
          controlHeight: 36,
          fontFamily: "Inter",
          colorInfo: "#1D4FFD",
          colorLink: "#2E62E9",
          colorError: "#F53D6B",
          colorPrimary: "#1E4DF5", // #28366F
          colorSuccess: "#4EBF61",
          colorWarning: "#FA942E",
          colorTextBase: "#364152",
          colorBorder: "#E3E8EF",
          colorTextPlaceholder: "#A9A9BC",
        },
        components: {
          Badge: { dotSize: 8 },
          Tag: { borderRadiusSM: 8 },
          Input: { controlHeight: 36, colorBorder: "#D1D1DB", colorTextDescription: "#6C6C89" },
          Divider: { colorSplit: "#EEF2F6" },
          Image: { colorBgMask: "rgba(0,0,0,0.75)" },
          Select: { colorBorder: "#E3E8EF", controlHeight: 36 },
          Button: {
            fontWeight: 500,
            borderRadius: 8,
            borderRadiusSM: 8,
            controlHeight: 36,
            controlHeightSM: 32,
            // dangerColor: "#D50B3E",
            colorBgSolid: "#121217",
            colorPrimary: "#2E62E9",
            defaultColor: "#3F3F50",
            paddingBlockSM: "4px 8px 4px",
            defaultHoverBg: "#F7F7F8",
            defaultHoverColor: "#3F3F50",
            defaultHoverBorderColor: "#E3E8EF",
            defaultBorderColor: "#D1D1DB",
          },
          Radio: { colorBorder: "#112260", colorText: "#121217" },
          Alert: { colorWarningBg: "#FFF9EB" },
          Checkbox: { colorBorder: "#D1D1DB" },
          Dropdown: {
            colorText: "#364152",
            colorPrimary: "#364152",
            controlItemBgActive: "#F8FAFC",
            controlItemBgActiveHover: "#F8FAFC",
          },
          Upload: { colorFillAlter: "#F8FAFC" },
          Collapse: { colorBorder: "#F2F2F2", headerBg: "#FFFFFF" },
          Card: { paddingLG: 16, colorBorderSecondary: "#e3e8ef" },
          Modal: { colorBgMask: "rgba(0,0,0,0.5)", titleColor: "#202939", titleFontSize: 18 },
          Typography: { colorText: "#121217", colorTextHeading: "#121217", colorTextDescription: "#6C6C89", fontWeightStrong: 500 },
          Table: {
            rowHoverBg: "#f1f6ff",
            fontWeightStrong: 400,
            borderColor: "#e3e8ef",
            headerColor: "#455690",
            cellPaddingBlock: 12.5,
            cellPaddingInline: 12.5,
          },
          Notification: {
            colorBgTextActive: "rgb(255, 255, 255)",
            colorText: "rgb(255, 255, 255)",
            colorTextHeading: "rgb(255, 255, 255)",
            colorIcon: "rgba(255, 255, 255, 0.45)",
            colorIconHover: "rgb(255, 255, 255)",
            colorBgElevated: "rgb(32, 41, 57)",
            paddingMD: 16,
            borderRadiusSM: 8,
            paddingContentHorizontalLG: 16.5,
            colorSuccess: "rgb(45, 202, 114)",
            colorWarning: "rgb(255, 194, 51)",
            colorError: "rgb(245, 61, 107)",
          },
          Tooltip: {
            colorBgSpotlight: "rgb(18, 25, 38)",
            fontSize: 12,
            borderRadius: 8,
            paddingXS: 12,
            paddingSM: 10,
            lineHeight: 1.5,
            controlHeight: 28,
            borderRadiusXS: 4,
          },
          Slider: {
            trackBg: "rgb(46, 98, 233)",
            trackHoverBg: "rgb(46, 98, 233)",
            handleLineWidth: 0,
            dotSize: 0,
            handleLineWidthHover: 0,
            borderRadiusXS: 8,
            colorPrimaryBorderHover: "rgb(255, 255, 255)",
            handleSize: 20,
            railSize: 8,
            controlSize: 10,
            colorBgElevated: "rgb(255, 255, 255)",
            colorFillContentHover: "rgb(255, 255, 255)",
            handleSizeHover: 20,
            handleColor: "rgb(255, 255, 255)",
            handleActiveOutlineColor: "rgb(255, 255, 255)",
          },
          Carousel: {
            dotGap: 5,
            dotWidth: 8,
            dotHeight: 8,
            dotActiveWidth: 8,
            colorBgContainer: "rgb(46, 98, 233)",
          },
          Form: { labelColor: "#364152", colorTextDescription: "#6C6C89" },
          Switch: { colorTextQuaternary: "#E3E8EF" },
          Layout: { bodyBg: "#FFFFFF", headerBg: "#FFFFFF" },
          Segmented: {
            borderRadius: 8,
            borderRadiusSM: 6,
            trackBg: "#EEF2F6",
            itemSelectedColor: "#121217",
            itemColor: "rgba(18,18,23,0.75)",
          },
          Popover: {
            boxShadowSecondary:
              "0px 2px 4px 0px #1212170A, 0px 5px 8px 0px #1212170A, 0px 10px 18px 0px #12121708, 0px 24px 48px 0px #12121708, 0px 0px 0px 1px #1212171A",
          },
          Popconfirm: {
            colorTextHeading: "#121217",
            colorTextDescription: "#3F3F50",
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
